import { Stack } from "@mui/material";
import { getWeekdayName } from "@sinch/utils/dateTime/format";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { SelectInput } from "@sinch/components/form/SelectInput/SelectInput";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const WeeklyOvertimeSettings: FC = () => {
  const { t } = useTranslation();
  const { field: limitField } = useMuiController<CreateIntervalFormData, "settings.limit">({
    name: "settings.limit",
  });
  const { field: resetDayField } = useMuiController<CreateIntervalFormData, "settings.resetDay">({
    name: "settings.resetDay",
  });

  return (
    <Stack spacing={2}>
      <NumberInput {...limitField} fullWidth label={t("RateUnit.weeklyLimit")} />
      <SelectInput
        {...resetDayField}
        disablePortal
        label={t("RateUnit.resetDay")}
        options={Array.from({ length: 7 }, (_, i) => ({
          value: i + 1,
          label: getWeekdayName(i + 1),
        }))}
      />
    </Stack>
  );
};
